import { render, staticRenderFns } from "./rejection-process-failure.vue?vue&type=template&id=22f6c002&scoped=true&"
import script from "./rejection-process-failure.vue?vue&type=script&lang=ts&"
export * from "./rejection-process-failure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6c002",
  null
  
)

export default component.exports